import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export type LayoutProps = {
	margin: number;
};

export const useStyles = makeStyles(theme => ({
	resultsList: {
		display: 'flex',
		flexFlow: 'wrap',
		flex: 1,
		margin: (props: LayoutProps) => `0px -${props.margin / 2}px`
	},
	resultsRow: {
		display: 'flex',
		flexFlow: 'nowrap',
		paddingLeft: 0
	}
}));
